var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OptionBuilder',{ref:"summarizeOb",attrs:{"optionName":"Resumir texto","iconName":"TwoFourPointedStar","id":"summarize","bottom":"64","disabled":_vm.disabled},on:{"selliaOptionBuilderClickSummarize":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }